// @ai-generated 2026-08-26T13:23:32+00:00 by matthias.gessinger@synqony.com using Claude Opus 5 (1M context)
import { type ApiDynamicExportRun } from '@Model';
import { exportRunResultLines } from '@utils/exportRunResult';
import styles from './ExportRunResultPreview.module.css';

interface ExportRunResultPreviewProps {
    run: ApiDynamicExportRun;
}

/**
 * The result in the width of a table cell: its first line, the rest in the detail panel the row
 * opens. A failed run used to render a dash here, which is a lot of space spent on saying nothing.
 * Only meaningful for a run `hasExportRunResult` accepts.
 */
export function ExportRunResultPreview({ run }: ExportRunResultPreviewProps) {
    const lines = exportRunResultLines(run);

    return (
        <span className={styles.preview} title={lines.join('\n')}>
            {lines[0]}
        </span>
    );
}
